import api from './api';

/** 功能所需最低等级（需求 5.1 矩阵：初级=DCA / 专业=对冲+形态 / 专家=自动交易） */
export const MEMBERSHIP_REQUIRED = {
    DCA_ASSISTANT: 1,
    HEDGE: 2,
    PATTERN: 2,
    AUTO_TRADING: 3,
} as const;

/** 定价档位（后端定价矩阵行） */
export interface MembershipPricing {
    level: number;
    levelName: string;
    monthlyPrice: string;
    yearlyPriceMonthly: string;
    dcaPlanLimit: number;
}

/** 订阅记录 */
export interface MembershipSubscription {
    id: number;
    level: number;
    period: string;
    amount: string;
    startTime: string;
    expireTime: string;
    openMethod: string;
    remark: string;
    createdAt: string;
}

/** 用户会员信息（会员中心） */
export interface MembershipUserInfo {
    currentLevel: number;
    levelName: string;
    expireTime: string | null;
    dcaPlanLimit: number;
    history: MembershipSubscription[];
    pricing: MembershipPricing[];
}

/** 运营检索用户结果 */
export interface MembershipOpsUser {
    userId: number;
    username: string;
    currentLevel: number;
    levelName: string;
    expireTime: string | null;
    history: MembershipSubscription[];
}

/** 运营开通/续期请求 */
export interface MembershipOpenRequest {
    userId: number;
    level: string;
    period: string;
    amount: string;
    remark?: string;
}

/** 当前用户会员信息（用户侧只读） */
export async function getMyMembership(): Promise<MembershipUserInfo | null> {
    const res = await api.get('/api/v1/membership/info');
    return res.data?.data ?? null;
}

/** 按用户名检索用户（ADMIN） */
export async function adminSearchMembershipUser(username: string): Promise<MembershipOpsUser | null> {
    const res = await api.get('/api/v1/admin/membership/users/search', {params: {username}});
    return res.data?.data ?? null;
}

/** 开通/续期会员（ADMIN） */
export async function adminOpenMembership(request: MembershipOpenRequest): Promise<MembershipSubscription | null> {
    const res = await api.post('/api/v1/admin/membership/open', request);
    return res.data?.data ?? null;
}

/** 用户订阅历史（ADMIN） */
export async function adminMembershipHistory(userId: number): Promise<MembershipSubscription[]> {
    const res = await api.get(`/api/v1/admin/membership/users/${userId}/history`);
    return res.data?.data ?? [];
}
